//Components
import { AssignUserRubric } from './assign-juges-rubic';
import { CreateUserForm } from './create-form';

export const actionValidator = (type, obj, handleClose) => {
  switch (type) {
    case 'AddUser':
      return <CreateUserForm obj={obj} type={type} handleClose={handleClose} />;
    case 'AssignJudgeEvent':
      return <AssignUserRubric obj={obj} type={type} handleClose={handleClose} />;
    default:
      return null;
  }
};
